import utils from "../../shared/utils";
import { take_pending_admin_route, clear_pending_admin_route } from "./utils/admin-redirect";

let current_id = null;
let current_clock = null;
const client = {
    client_join(params){
        if(params == null)
            return;

        window.store.commit("setGame", params);

        client.handle_client();
    },
    // A second tab/device joined with this same session (see client_join in
    // server.js) - stop this one's auto-reconnect instead of letting both
    // tabs evict each other back and forth forever (see the 2026-09-15
    // "disconnected -> panel -> disconnected" report). ConnectionOverlay.vue
    // shows the explanation via the 'session_conflict' network state.
    session_already_active(){
        window.network.reconect = false;
        window.store.commit("setNetwork", "session_conflict");
    },
    client_auth(params){
        if(params == null)
            return;

        window.store.commit("setGame", params);

        client.handle_client();
    },
    client_debug(params){
        console.log(window.store.state.game)
    },
    // Reply to VALIDATE_JOIN_CODE (see JoinByCode.vue) - {valid, stage_name}
    // sent directly to this client, never broadcast. Purely a store commit:
    // the component that asked for the check reacts to it and decides
    // whether/where to navigate, this handler has no routing side effect.
    join_code_result(params){
        window.store.commit("setJoinCodeResult", params);
    },
    // Reply to CHECK_USERNAME (Auth.vue step 1) - {available, username}.
    username_check_result(params){
        window.store.commit("setUsernameCheckResult", params);
    },
    // Reply to CLIENT_AUTH (Auth.vue step 2) - {ok, reason?, message?}. On
    // success the normal CLIENT_UPDATE broadcast (handled elsewhere) still
    // does the actual role/route transition - this is purely the request's
    // own success/failure signal so Auth.vue can resolve its loading state.
    client_auth_result(params){
        window.store.commit("setClientAuthResult", params);
    },
    client_update(params){
        if(params == null)
            return;

        var game = Object.assign({}, window.store.state.game);

        if(current_id != params.current_question)
        {
            if(current_clock)
                clearInterval(current_clock);
        }
        current_id = params.current_question

        if(params.user){
            game.user = params.user;
        }

        // Online mode's player-facing flows (MySeasons/MyStages/StageActivity)
        // run entirely over the REST API (api.js), not this websocket - but
        // every browser tab still opens this connection unconditionally
        // (main.js), and the server still answers every join/login/broadcast
        // with a CLIENT_UPDATE, so a player/guest tab keeps receiving these
        // regardless. Without this gate, an unrelated event-mode broadcast
        // (an admin editing some other season) would clobber the local state
        // StageActivity.vue fakes via setQuestion/setClients/etc mid-answer -
        // the same class of staleness bug the REST rewrite was meant to fix,
        // just moved one layer down. Staff logging in via online mode's
        // Login.vue bridge still authenticate over this same socket, so
        // they're deliberately excluded (role won't be PLAYER/GUEST for them).
        const is_restricted_online_player = window.MODE == utils.APP_MODES.ONLINE
            && (!game.user || game.user.role == utils.USER_ROLES.PLAYER || game.user.role == utils.USER_ROLES.GUEST);

        if(!is_restricted_online_player){
            game.users = params.users;
            game.questions = params.questions;
            game.seasons = params.seasons;
            game.stages = params.stages;
            game.season_users = params.season_users;
            // Pre-existing gap (predates today's sector work) - a ranking
            // registered/edited/removed by any admin only ever showed up
            // for whoever was there for the one-off CLIENT_JOIN/CLIENT_AUTH
            // full payload, same class of bug as stage_playback/sectors
            // below.
            game.rankings = params.rankings;
            game.logos = params.logos;
            game.styles = params.styles;
            game.images = params.images;
            game.state = params.state;
            game.current_question = params.current_question;
            game.question = params.question;
            game.clients = params.clients;
            // Missing from this list until the per-stage join QR needed them
            // to actually refresh live - previously they only ever arrived
            // via the one-off full-state payload sent on CLIENT_JOIN/CLIENT_AUTH,
            // so e.g. Stages.vue's "Iniciar etapa" QR wouldn't show up for
            // anyone until they reloaded the page.
            game.stage_playback = params.stage_playback;
            game.join_code = params.join_code;
            // EVENT mode's "which season is live right now" pointer - see
            // server.js's own comment on game.active_season_id.
            game.active_season_id = params.active_season_id;
            // Same class of gap as stage_playback/join_code above - without
            // this, a sector saved/edited/removed by any admin only ever
            // showed up for whoever was there for the one-off CLIENT_JOIN/
            // CLIENT_AUTH full payload, never as a live update afterwards.
            game.sectors = params.sectors;
            // Set by RankingAction/_run_feedback_batch (server/actions/,
            // server.js) - see store/index.js for what each holds.
            game.active_ranking = params.active_ranking;
            game.feedback_stats = params.feedback_stats;
            // Set alongside GAME_STATES.PAUSED while stage playback holds at
            // a sector (see _run_crossed_sectors_then_hold) - Pause.vue's own
            // read of it.
            game.paused_sector_name = params.paused_sector_name;
            // Video activities' "waiting for every player to load" round -
            // see server.js's _await_media_ready / components/type/Content.vue.
            game.media_sync = params.media_sync;
            // Page of a presenter-driven PDF (utils.is_presenter_slides) -
            // see server.js's presenter_step / components/PdfSlides.vue.
            game.content_page = params.content_page;
            // Stage animation being shown (GAME_STATES.INTERLUDE) - see
            // server.js's _show_interlude / views/Interlude.vue.
            game.interlude = params.interlude;
            game.paused_sector_id = params.paused_sector_id;
        }

        window.store.commit("setGame", game);
        client.handle_client();
    },
    timer_stop(params){
        if(current_clock){
            clearInterval(current_clock);
        }
    },
    client_toast(params){      
        if(params == null)
            return;
        window.toast[params.type](params.message);
    },
    client_clean(params){
        if(params == true && window.store.state.game.user.role == utils.USER_ROLES.MANAGER)
        {
            utils.reset_client();
            return;
        }
        else if(params == null && window.store.state.game.user.role == utils.USER_ROLES.PLAYER){
            utils.reset_client();
        }
    },
    client_reload(params){
        if(window.store.state.game.user.role == utils.USER_ROLES.PLAYER || window.store.state.game.user.role == utils.USER_ROLES.MANAGER){
            if(typeof GameInterface !== 'undefined')
                GameInterface.GameReload("");
            else
                window.location.href="/";
        }
    },
    client_sync_handshake(params){
        const game = window.store.state.game;
        // A delayed handshake must never restore an old game snapshot or drive routing.
        // CLIENT_UPDATE is the authority for the TITLE -> CHOICES transition.
        if(!params || game.current_question != params.question_id
            || game.state !== utils.GAME_STATES.TITLE) return;
        if(game.question?.question?.start_time !== params.timestamp) return;
        window.network.send(window.RPC.CLIENT_SYNC_HANDSHAKE, Date.now() < params.timestamp);
    },
    save_avatar(params){
        if(params == null)
            return;

        if(params.id != window.store.state.game.user.id) return;
        var game = Object.assign({}, window.store.state.game);
        game.user.avatar_style = params.avatar_style;
        window.store.commit("setGame", game);
    },
    sync_handshake_info(params){
        if(params == null)
            return;

        var game = Object.assign({}, window.store.state.game);

        game.handshakes = params.handshakes;

        window.store.commit("setGame", game);
        //emit('handshakes');
    },
    client_ping(params){
        if([utils.USER_ROLES.PLAYER, utils.USER_ROLES.MANAGER].includes(window.store.state.game.user?.role)
            && window.MODE != utils.APP_MODES.ONLINE)
        {
            // CLIENT_PING now only carries {state, current_question} (see server.js) -
            // it used to carry the whole game object every 8s just so this check could
            // piggyback a full state refresh on it. Ask for one explicitly instead.
            if(params && (params.state != window.store.state.game.state
                || params.current_question != window.store.state.game.current_question))
            {
                window.network.send(window.RPC.REQUEST_SYNC, null);
            }else{
                client.handle_client();
            }
        }

        window.network.send(window.RPC.CLIENT_PING, null);
    },
    client_kick(){
        if(window.store.state.game.user.role == utils.USER_ROLES.PLAYER 
        || window.store.state.game.user.role == utils.USER_ROLES.MANAGER){
            window.network.wso.close();
            localStorage.removeItem("session");
            sessionStorage.removeItem("event_session");
            if(typeof GameInterface === 'undefined')
                window.location.reload();
            else
                GameInterface.GameReload("");
        }
    },
    edit_activity(params){
    },
    cancel_launch_activity(params){
        var game = Object.assign({}, window.store.state.game);
        game.synchronizing = false;
        window.store.commit("setGame", game);
    },
    update_view(params){        
        var game = Object.assign({}, window.store.state.game);
        var cli = game.clients.find((usr) => usr.uuid == params.uuid);
        if(cli)
        {
            if(utils.is_valid_parameter(params.current_view))
                cli.current_view = params.current_view;
            if(utils.is_valid_parameter(params.current_activity))
                cli.current_activity = params.current_activity;
        }

        window.store.commit("setGame", game);
    },
    // Utils
    handle_routes(){
        if(/^\/login(?:\/|$)/.test(window.location.pathname)){
            var user = window.store.state.game.user;
            if(user == null || user.role == utils.USER_ROLES.GUEST)
                return false;
        }

        return true;
    },
    handle_client(){
        if(this.handle_routes() == false) return;

        const user = window.store.state.game.user;
        if (!user) return;
        // Logged in as something other than staff - a stashed admin deep
        // link can never be honored for this session, drop it.
        if (![utils.USER_ROLES.ADMINISTRATOR, utils.USER_ROLES.ASSISTANT, utils.USER_ROLES.GUEST].includes(user.role))
            clear_pending_admin_route();
        if (window.MODE === utils.APP_MODES.EVENT && user.role === utils.USER_ROLES.MANAGER && !user.season_id) {
            if (window.router.currentRoute.value.name !== 'Login') window.router.push({name: 'Login'});
            return;
        }
        let oldRoute = window.router.currentRoute._value.name;

        switch(window.store.state.game.user.role)
        {
            case utils.USER_ROLES.ADMINISTRATOR:
            case utils.USER_ROLES.ASSISTANT:
            {
                // This runs on every single CLIENT_UPDATE (i.e. on every save/
                // reorder/force-start anywhere in the admin tools, from ANY
                // connected staff member) - it used to force-navigate back to
                // "Panel" unless the route was literally named "Panel", which
                // yanked staff out of Users/Stages mid-edit the moment
                // anything changed. Panel is still the default landing route
                // (on login/join, below), but once staff are on any of these
                // admin-only routes a CLIENT_UPDATE must never move them.
                // Every admin screen is flagged meta.admin in router/index.js
                // (single list, also used by its staff-only guard).
                // A deep link (e.g. /panel/eventos/11/etapas/50) bounced by the
                // router guard before this staff session existed - take them
                // there now instead of the default Panel landing.
                const pending_route = take_pending_admin_route();
                if(pending_route){
                    window.router.push(pending_route);
                    break;
                }
                const current_meta = window.router.currentRoute._value.meta || {};
                if(current_meta.admin) break;
                window.router.push({name: "Panel"});
                break;
            }
            case utils.USER_ROLES.MANAGER: {
                switch(window.store.state.game.state){
                    case window.utils.GAME_STATES.IDLE:
                    // AUTH ("SELECCION USUARIOS") is guests actively
                    // registering right now - exactly when the projected QR
                    // matters most, so the MANAGER stays on Home.vue's big
                    // screen here too instead of following guests into
                    // Auth.vue's registration wizard (which has nothing for
                    // a MANAGER to do - no username/jersey to pick, and
                    // would even show them the join-code gate screen).
                    case window.utils.GAME_STATES.AUTH: {
                        if("Home" == oldRoute) return;
                        window.router.push({name: "Home"});
                        break;
                    }
                    case window.utils.GAME_STATES.TITLE: {
                        if("Title" == oldRoute) return; 
                        window.router.push({name: "Title"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.CHOICES: {
                        if("Activity" == oldRoute) return; 
                        window.router.push({name: "Activity"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.RESULT: {
                        if("Result" == oldRoute) return; 
                        window.router.push({name: "Result"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.RANKING: {
                        if("Ranking" == oldRoute) return; 
                        window.router.push({name: "Ranking"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.STOPPED: {
                        if("Stop" == oldRoute) return; 
                        window.router.push({name: "Stop"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.PAUSED: {
                        if("Pause" == oldRoute) return; 
                        window.router.push({name: "Pause"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.INTERLUDE: {
                        if("Interlude" == oldRoute) return;
                        window.router.push({name: "Interlude"});
                        break;
                    }
                    case window.utils.GAME_STATES.END: {
                        if("End" == oldRoute) return; 
                        window.router.push({name: "End"}); 
                        break;
                    }
                    default: window.router.push({name: "Home"}); break;
                }
                break;
            }
            case utils.USER_ROLES.PLAYER: {
                // This whole switch exists to keep a player's route in sync with
                // the centralized, synchronous game.state broadcast - that only
                // means something in event mode. In online mode there is no
                // shared session to stay in sync with: the player navigates at
                // their own pace via MySeasons/MyStages/StageActivity, driven by
                // their own clicks, not by CLIENT_UPDATE (which fires often and
                // would otherwise yank them back to Home/Title/Activity mid-stage).
                if(window.MODE == utils.APP_MODES.ONLINE) break;
                switch(window.store.state.game.state){
                    // Home.vue has nothing for an already-registered PLAYER
                    // (its content is either the MANAGER's big-screen QR or
                    // the GUEST-facing "join"/"create account" prompts) - a
                    // player who just finished Auth.vue's jersey step used to
                    // land here with a dead-end blank screen whenever the
                    // admin hadn't separately flipped the game into AUTH
                    // state first. IDLE now goes to the same waiting room as
                    // AUTH: registering always leads to Lobby.
                    case window.utils.GAME_STATES.IDLE:
                    case window.utils.GAME_STATES.AUTH: {
                        if("Lobby" == oldRoute) return;
                        window.router.push({name: "Lobby"});
                        break;
                    }
                    case window.utils.GAME_STATES.TITLE: {
                        if("Title" == oldRoute) return; 
                        window.router.push({name: "Title"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.CHOICES: {
                        if("Activity" == oldRoute) return; 
                        window.router.push({name: "Activity"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.RESULT: {
                        if("Result" == oldRoute) return;
                        window.router.push({name: "Result"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.RANKING: {
                        if("Ranking" == oldRoute) return;
                        window.router.push({name: "Ranking"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.STOPPED: {
                        if("Stop" == oldRoute) return;
                        window.router.push({name: "Stop"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.PAUSED: {
                        if("Pause" == oldRoute) return;
                        window.router.push({name: "Pause"}); 
                        break;
                    }
                    case window.utils.GAME_STATES.INTERLUDE: {
                        if("Interlude" == oldRoute) return;
                        window.router.push({name: "Interlude"});
                        break;
                    }
                    case window.utils.GAME_STATES.END: {
                        if("End" == oldRoute) return;
                        window.router.push({name: "End"}); 
                        break;
                    }
                    default: window.router.push({name: "Home"}); break;
                } 
                break;
            }
            case utils.USER_ROLES.GUEST: {
                if(window.MODE == utils.APP_MODES.ONLINE) break;

                // Validated a join code (whole-game or a live stage's, see
                // JoinByCode.vue/VALIDATE_JOIN_CODE) - let them reach/stay on
                // Auth regardless of the global game.state, so a late joiner
                // can register mid-stage instead of being bounced to Home.
                if(window.store.state.join_verified){
                    if("Auth" == oldRoute) return;
                    window.router.push({name: "Auth"});
                    break;
                }

                // Arrived via a scanned/shared "/join/<code>" link - don't
                // bounce away before Auth.vue's own JoinByCode gate has had a
                // chance to validate that code itself.
                const current_route = window.router.currentRoute._value;
                if(current_route.name === "Auth" && current_route.params.event_code)
                    return;

                switch(window.store.state.game.state){
                    case window.utils.GAME_STATES.IDLE: {
                        if("Home" == oldRoute) return;
                        window.router.push({name: "Home"});
                        break;
                    }
                    case window.utils.GAME_STATES.AUTH: {
                        if("Auth" == oldRoute) return;
                        window.router.push({name: "Auth"});
                        break;
                    }
                    default: {
                        if("Home" == oldRoute) return;
                        window.router.push({name: "Home"});
                        break;
                    }
                }
                break;
            }
        }
        //window.network.wso.send(JSON.stringify({action: window.RPC.UPDATE_VIEW, params: {view: window.router.currentRoute._value.name, activity: (window.store.state.game.question) ? window.store.state.game.question.id : null}}))
    }
};


export default client;
